import { Entity } from '@/interfaces'
import model from './model'
import repository from './repository'

const cmsButtonBlockEntity: Entity = {
  model: model,
  repository: repository,
}

export default cmsButtonBlockEntity
